import { defineMessages } from 'react-intl';

export const i18n: {
	taskTypeFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskTypeFilterNoOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	taskTypeFilterLabel: {
		id: 'search-page.salesforce.filter.taskType',
		defaultMessage: 'Task Type',
		description: 'Label for filtering Salesforce tasks by their type',
	},
	taskTypeFilterNoOptions: {
		id: 'search-page.salesforce.filter.taskType.no-options',
		defaultMessage: 'No task types available',
		description:
			'Message shown in the Salesforce task type filter dropdown when no type options are available',
	},
});
